import { Component } from "@angular/core";

@Component({
	selector: "app-client-landing",
	templateUrl: "./client-landing.component.html",
	styleUrls: ["./client-landing.component.scss"]
})
export class ClientLandingComponent {}
